import React from 'react';
import PageHeader from '../ui/PageHeader';
import StepCard, { InfoTile, LinkTile } from '../ui/StepCard';
import ContractRow from '../ui/ContractRow';
import Seo from '../ui/Seo';
import { CONTRACTS } from '../../data/site';
import soldex from '../../assets/images/soldex.jpg';

const chain = CONTRACTS.solana;

const SolBuyPage = () => (
  <main className="wrap">
    <Seo title="Buy $BOOP on Solana" description="Step-by-step: buy the Wormhole-bridged $BOOP on Solana with Jupiter or Raydium." path="/buy/solana" />
    <PageHeader back={{ to: '/buy', label: 'Back to options' }} eyebrow="🟣 SOLANA · SPL (WORMHOLE)" title="How to buy $BOOP on" highlight="Solana" />

    <div className="grid items-start gap-6 pt-7 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] lg:gap-10 lg:pt-12">
      <ol className="grid gap-4 lg:gap-5">
        <StepCard n={1} title="Load up your favourite SOL DEX">
          <p>Choose your preferred DEX to trade:</p>
          <div className="grid gap-3 sm:grid-cols-2">
            <LinkTile href="https://jupiter.xyz" title="Jupiter" sub="Recommended option" />
            <LinkTile href="https://raydium.io" title="Raydium" sub="Alternative option" />
          </div>
        </StepCard>
        <StepCard n={2} title="Connect your wallet">
          <p>Any Solana compatible wallet will work. Recommended options:</p>
          <div className="grid gap-3 sm:grid-cols-2">
            <InfoTile title="Phantom" sub="Most popular Solana wallet" />
            <InfoTile title="Solflare" sub="Feature-rich Solana wallet" />
          </div>
          <p className="font-semibold">Make sure you have some $SOL in your wallet to execute the trade.</p>
          <p className="text-sm text-muted">You can withdraw from a CEX or buy directly through your wallet&apos;s interface if supported.</p>
        </StepCard>
        <StepCard n={3} title="Set up your trade">
          <p>
            <b>YOU&apos;RE SELLING:</b> select your source currency (e.g. $SOL)
          </p>
          <p>
            <b>YOU&apos;RE BUYING:</b> paste the BOOP (Wormhole) contract address below
          </p>
        </StepCard>
        <StepCard n={4} title="Execute the trade">
          <p>Once the platform gives you a quote, execute the trade.</p>
        </StepCard>

        <li className="card !bg-sun">
          <h3 className="text-xl font-bold">BOOP contract address (Solana)</h3>
          <p className="mb-3 text-sm font-medium">Always verify the contract address before making any transaction.</p>
          <ContractRow chain={chain} showExplorer />
        </li>
      </ol>

      <aside className="lg:sticky lg:top-24">
        <div className="card">
          <h3 className="text-xl font-bold">Example interface</h3>
          <p className="section-sub">Here&apos;s how Jupiter&apos;s swap interface looks.</p>
          <div className="art">
            <img src={soldex} alt="Jupiter swap interface example" className="h-auto w-full" loading="lazy" />
          </div>
        </div>
        <a className="btn mt-4 w-full py-3 text-lg" href={chain.relay} target="_blank" rel="noopener noreferrer">
          Or buy on Relay ↗
        </a>
      </aside>
    </div>
  </main>
);

export default SolBuyPage;
